import { render, staticRenderFns } from "./ErrorWrapper.vue?vue&type=template&id=39efc376&"
import script from "./ErrorWrapper.vue?vue&type=script&lang=js&"
export * from "./ErrorWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports